
import { StepValidation } from "../trackLeadPayload";

export const insuranceSteps: StepValidation = {
    personalInfo: ["firstName", "lastName", "email", "phone", "language", "privacyPolicy", "zip"],
    companyInfo: ["enterpriseNumber", "enterpriseName"],
    investment: ["carModel", "grossInvestmentAmount"],
    summary: [],
}
